import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

interface LeadSource { lead_id: number; lead_name: string; lead_notes: string; }

const API = environment.api + 'lead-sources';

/**
 * Settings > Lead Sources (moved from twin-ci leads_list / add / edit / del; mockup settings
 * "Lead Sources"). Every lead source A-Z with a search (agreed); add and edit in a dialog. Kept from
 * twin-ci: name saved upper-cased, duplicates allowed, delete is soft (jobs keep their lead).
 */
@Component({
    selector: 'app-lead-sources',
    templateUrl: './lead-sources.component.html',
    styleUrls: ['./lead-sources.component.scss']
})
export class LeadSourcesComponent implements OnInit {
    leads: LeadSource[] = [];
    loaded = false;
    search = '';
    message = '';
    error = '';

    editing: LeadSource = null;   // the dialog's record; lead_id 0 = new
    saving = false;
    formError = '';
    nameError = '';
    deleting: LeadSource = null;

    constructor(private http: HttpClient) { }

    ngOnInit() {
        this.load();
    }

    private load() {
        this.http.get<{ data: LeadSource[] }>(API).subscribe(
            res => {
                this.leads = res.data || [];
                this.loaded = true;
            },
            err => this.error = typeof err === 'string' ? err : 'The lead sources could not be loaded.'
        );
    }

    get shown(): LeadSource[] {
        const q = this.search.trim().toLowerCase();
        return !q ? this.leads : this.leads.filter(l => (l.lead_name + ' ' + (l.lead_notes || '')).toLowerCase().indexOf(q) !== -1);
    }

    add() {
        this.open({ lead_id: 0, lead_name: '', lead_notes: '' });
    }

    edit(l: LeadSource) {
        this.open(Object.assign({}, l));
    }

    private open(l: LeadSource) {
        this.editing = l;
        this.formError = '';
        this.nameError = '';
        this.message = '';
    }

    close() {
        this.editing = null;
    }

    save() {
        const l = this.editing;
        this.nameError = l.lead_name.trim() ? '' : 'Enter the lead name.';
        if (this.nameError) {
            return;
        }
        const body = { lead_name: l.lead_name, lead_notes: l.lead_notes || '' };
        const request = l.lead_id ? this.http.put<any>(API + '/' + l.lead_id, body) : this.http.post<any>(API, body);
        this.saving = true;
        this.formError = '';
        request.subscribe(
            res => {
                this.saving = false;
                this.editing = null;
                this.message = res.message;
                this.load();
            },
            err => {
                this.saving = false;
                this.formError = typeof err === 'string' ? err : 'The lead source could not be saved.';
            }
        );
    }

    confirmDelete(l: LeadSource) {
        this.deleting = l;
        this.message = '';
    }

    remove() {
        this.saving = true;
        this.http.delete<any>(API + '/' + this.deleting.lead_id).subscribe(
            res => {
                this.saving = false;
                this.deleting = null;
                this.message = res.message;
                this.load();
            },
            err => {
                this.saving = false;
                this.deleting = null;
                this.error = typeof err === 'string' ? err : 'The lead source could not be deleted.';
            }
        );
    }
}
